import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Spacer,
  VStack,
} from "@chakra-ui/react";
import { Helmet } from "react-helmet";

import SiteStatusBar from "./molecules/SiteStatusBar";
import Sponsors from "./molecules/Sponsors";
import DashboardHeader from "./molecules/DashboardHeader";
import React, { useState } from "react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { MenuOptions } from "./types/enums";
import Faq from "./molecules/Faq";
import Highlight from "./molecules/Highlight";
import Aree from "./molecules/Aree";
import Foods from "./molecules/Food";
import Tournaments from "./molecules/Tournament";
import Programmi from "./molecules/Programmi";

export default function Dashboard() {
  const [selectedPage, setSelectedPage] = useState<String>(MenuOptions[0]);

  return (
    <Box>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <DashboardHeader />
      <Flex>
        <Flex
          bottom="0"
          backgroundColor="talesPrimary.500"
          flexDir="column"
          p="20px"
          alignItems="stretch"
          shadow="md"
        >
          <SiteStatusBar />
          <VStack spacing="15px" alignItems="stretch" mt="20px">
            {MenuOptions.map((opt) => (
              <Button key={opt} onClick={() => setSelectedPage(opt)}>
                {opt}
              </Button>
            ))}
          </VStack>
        </Flex>

        <Box w={"100%"}>
          <Flex p="20px" backgroundColor="talesYellow.300" alignItems="center">
            <ChevronRightIcon />{" "}
            <Heading size="base" mx="20px">
              {selectedPage}
            </Heading>
            <Spacer />
          </Flex>

          <Container maxW="8xl" p="20px">
            {selectedPage === "Sponsor" && <Sponsors />}
            {selectedPage === "Faq" && <Faq />}
            {selectedPage === "Evidenza" && <Highlight />}
            {selectedPage === "Aree" && <Aree />}
            {selectedPage === "Food" && <Foods />}
            {selectedPage === "Tornei" && <Tournaments />}
            {selectedPage === "Programma" && <Programmi />}
          </Container>
        </Box>
      </Flex>
    </Box>
  );
}
